<template>
  <b-tab title="Partícula Magnética" :active="ativo" class="m-0 p-0">
    <div id="screen-form" class="pl-2 pr-2 mt-2">
      <div id="ParticulaMagnetica">
        <b-container fluid>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::: PARTE SUPERIOR DO RELATORIO ::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row>
            <b-col cols="3">
              <b-img
                :src="require('/static/images/netech.png')"
                fluid
                alt="Responsive image"
                width="230"
              />
            </b-col>

            <b-col cols="6" class="pt-1">
              <h4 class="exo-2 center-text p-4">
                RELATÓRIO DE ENSAIO POR PARTÍCULAS MAGNÉTICAS
              </h4>
            </b-col>

            <b-col cols="3" class="pl-5">
              <b-row><p class="m-0 p-0">ID. Relatório</p></b-row>
              <b-row><b-form-input size="sm" v-model="pm.numero" /></b-row>
              <b-row><p class="m-0 p-0">Data</p></b-row>
              <b-row>
                <b-form-datepicker
                  size="sm"
                  v-model="pm.data"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                />
              </b-row>
            </b-col>
          </b-row>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::           LATERAL ESQUERDA          :::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row>
            <b-col cols="6" class="m-0 p-0">
              <b-row class="m-0 p-0">
                <div class="p-0 pr-3 m-0">
                  <b-img
                    :src="
                      imagem == null
                        ? require('/static/images/report.png')
                        : imagem
                    "
                    class="max-size-img"
                    center
                    fluid
                  />
                </div>
              </b-row>
              <b-row class="m-0 p-0 pr-3">
                <b-col cols="12" class="p-0 mt-2">
                  <div class="separador-div">
                    <strong>INSPEÇÃO E DESCONTINUIDADES</strong>
                  </div>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-table
                    id="table-item"
                    bordered
                    hover
                    small
                    :items="pm.itens"
                    :fields="fields.item_inspecao"
                  >
                    <template #cell(quantidade)="data">
                      <b-form-input size="sm" v-model="data.item.quantidade" />
                    </template>

                    <template #cell(descricao)="data">
                      <b-form-input size="sm" v-model="data.item.descricao" />
                    </template>

                    <template #cell(local)="data">
                      <b-form-input size="sm" v-model="data.item.local" />
                    </template>

                    <template #cell(tipo)="data">
                      <b-form-input size="sm" v-model="data.item.tipo" />
                    </template>

                    <template #cell(dimensao)="data">
                      <b-form-input size="sm" v-model="data.item.dimensao" />
                    </template>

                    <template #cell(laudo)="data">
                      <b-form-input size="sm" v-model="data.item.laudo" />
                    </template>
                  </b-table>
                </b-col>
                <b-col cols="12" class="p-0">
                  <div class="separador-div">
                    <strong>DOCUMENTAÇÃO DE REFERÊNCIA</strong>
                  </div>
                </b-col>
                <b-col cols="6" class="text-left p-0">
                  <p class="m-0 p-0">Procedimento / Procedure</p>
                </b-col>
                <b-col cols="6" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Norma / Standard</p>
                </b-col>
                <b-col cols="6" class="p-0">
                  <b-form-input size="sm" v-model="pm.procedimento" />
                </b-col>
                <b-col cols="6" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="pm.norma" />
                </b-col>
              </b-row>
            </b-col>
            <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
            <!-- :::::::::::::::::           LATERAL DIREITA           :::::::::::::::::: -->
            <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
            <b-col cols="6" class="m-0 p-0">
              <b-row class="m-0 p-0">
                <b-col cols="12" class="p-0">
                  <div class="separador-div">
                    <strong>INFORMAÇÕES SOBRE O EQUIPAMENTO</strong>
                  </div>
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">Descrição / Description</p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="equipamento.nome" />
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">Identificação / Identification</p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="identificacao" />
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">Dimensões / Dimensions</p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="equipamento.dimensoes" />
                </b-col>
                <b-col cols="6" class="text-left p-0">
                  <p class="m-0 p-0">Material / Material</p>
                </b-col>
                <b-col cols="6" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Peso / Weight</p>
                </b-col>
                <b-col cols="6" class="p-0">
                  <b-form-input size="sm" v-model="pm.material" />
                </b-col>
                <b-col cols="6" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="equipamento.peso" />
                </b-col>
                <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
                <b-col cols="12" class="p-0">
                  <div class="separador-div mt-2">
                    <strong>TÉCNICA APLICADA</strong>
                  </div>
                </b-col>
                <b-col cols="4" class="text-left p-0">
                  <p class="m-0 p-0">Descrição / Description</p>
                </b-col>
                <b-col cols="4" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Via / Conduction</p>
                </b-col>
                <b-col cols="4" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Decantação / Decantat.</p>
                </b-col>
                <b-col cols="4" class="p-0">
                  <b-form-input size="sm" v-model="pm.tecnica" />
                </b-col>
                <b-col cols="4" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="pm.via" />
                </b-col>
                <b-col cols="4" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="pm.decantacao" />
                </b-col>
                <b-col cols="4" class="text-left p-0">
                  <p class="m-0 p-0">Corrente / Current</p>
                </b-col>
                <b-col cols="4" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Temperatura / Temp.</p>
                </b-col>
                <b-col cols="4" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Superfície / Surface</p>
                </b-col>
                <b-col cols="4" class="p-0">
                  <b-form-input size="sm" v-model="pm.corrente" />
                </b-col>
                <b-col cols="4" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="pm.temperatura" />
                </b-col>
                <b-col cols="4" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="pm.superficie" />
                </b-col>
                <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
                <b-col cols="12" class="p-0">
                  <div class="separador-div mt-2">
                    <strong>EQUIPAMENTO PARA MAGNETIZAÇÃO</strong>
                  </div>
                </b-col>
                <b-col cols="6" class="text-left p-0">
                  <p class="m-0 p-0">Descrição / Description</p>
                </b-col>
                <b-col cols="6" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Fabricante / Manufacturer</p>
                </b-col>
                <b-col cols="6" class="p-0">
                  <b-form-input size="sm" v-model="pm.instrumento.descricao" />
                </b-col>
                <b-col cols="6" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="pm.instrumento.fabricante" />
                </b-col>
                <b-col cols="4" class="text-left p-0">
                  <p class="m-0 p-0">Modelo / Model</p>
                </b-col>
                <b-col cols="4" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Nº Série / Series No.</p>
                </b-col>
                <b-col cols="4" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Certificado / Certificate</p>
                </b-col>
                <b-col cols="4" class="p-0">
                  <b-form-input size="sm" v-model="pm.instrumento.modelo" />
                </b-col>
                <b-col cols="4" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="pm.instrumento.serie" />
                </b-col>
                <b-col cols="4" class="p-0 pl-2">
                  <b-form-input
                    size="sm"
                    v-model="pm.instrumento.certificado"
                  />
                </b-col>
                <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
                <b-col cols="12" class="p-0">
                  <div class="separador-div mt-2">
                    <strong>PRODUTOS UTILIZADOS</strong>
                  </div>
                </b-col>
                <b-col cols="6" class="text-left p-0">
                  <p class="m-0 p-0">Produto / Product</p>
                </b-col>
                <b-col cols="6" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Fabricante / Manufacturer</p>
                </b-col>
                <b-col cols="6" class="p-0">
                  <b-form-input size="sm" v-model="pm.particula.descricao" />
                </b-col>
                <b-col cols="6" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="pm.particula.fabricante" />
                </b-col>
                <b-col cols="3" class="text-left p-0">
                  <p class="m-0 p-0">Tipo / Type</p>
                </b-col>
                <b-col cols="3" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Cor / Color</p>
                </b-col>
                <b-col cols="3" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Concentração</p>
                </b-col>
                <b-col cols="3" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Lote / Batch</p>
                </b-col>
                <b-col cols="3" class="p-0">
                  <b-form-input size="sm" v-model="pm.particula.tipo" />
                </b-col>
                <b-col cols="3" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="pm.particula.cor" />
                </b-col>
                <b-col cols="3" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="pm.particula.concentracao" />
                </b-col>
                <b-col cols="3" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="pm.particula.lote" />
                </b-col>
                <b-col cols="6" class="text-left p-0">
                  <p class="m-0 p-0">Produto / Product</p>
                </b-col>
                <b-col cols="6" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Fabricante / Manufacturer</p>
                </b-col>
                <b-col cols="6" class="p-0">
                  <b-form-input size="sm" v-model="pm.distensor.descricao" />
                </b-col>
                <b-col cols="6" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="pm.distensor.fabricante" />
                </b-col>
                <b-col cols="3" class="text-left p-0">
                  <p class="m-0 p-0">Tipo / Type</p>
                </b-col>
                <b-col cols="3" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Cor / Color</p>
                </b-col>
                <b-col cols="3" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Concentração</p>
                </b-col>
                <b-col cols="3" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Lote / Batch</p>
                </b-col>
                <b-col cols="3" class="p-0">
                  <b-form-input size="sm" v-model="pm.distensor.tipo" />
                </b-col>
                <b-col cols="3" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="pm.distensor.cor" />
                </b-col>
                <b-col cols="3" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="pm.distensor.concentracao" />
                </b-col>
                <b-col cols="3" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="pm.distensor.lote" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::: PARTE DETALHES DO RELATORIO :::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row>
            <b-col cols="12" class="p-0 mt-2">
              <div class="separador-div">
                <strong>OBSERVAÇÕES GERAIS</strong>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="p-0">
              <b-form-textarea v-model="pm.observacao" :rows="linhas" />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="p-0 mt-2">
              <div class="separador-div">
                <strong>LEGENDA</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="bordered text-left pl-4 pb-2 legend">
            <b-col cols="4" class="p-0">
              <p class="m-0 p-0 mt-1 legenda-text">T - TRINCA</p>
              <p class="m-0 p-0 legenda-text">AT - AGRUPAMENTO DE TRINCAS</p>
              <p class="m-0 p-0 legenda-text">TL - TRINCA LONGITUDINAL</p>
              <p class="m-0 p-0 legenda-text">TT - TRINCA TRANSVERSAL</p>
              <p class="m-0 p-0 legenda-text">TR - TRINCA RAMIFICADA</p>
            </b-col>
            <b-col cols="4" class="p-0">
              <p class="m-0 p-0 mt-1 legenda-text">PG - POROSIDADE AGRUPADA</p>
              <p class="m-0 p-0 legenda-text">PO - POROSIDADE</p>
              <p class="m-0 p-0 legenda-text">FA - FALTA DE FUSÃO</p>
              <p class="m-0 p-0 legenda-text">MO - MORDEDURA</p>
              <p class="m-0 p-0 legenda-text">TF - TRINCA DE FADIGA</p>
            </b-col>
            <b-col cols="4" class="p-0">
              <p class="m-0 p-0 mt-1 legenda-text">SO - SOLDA</p>
              <p class="m-0 p-0 legenda-text">MB - METAL BASE</p>
              <p class="m-0 p-0 legenda-text">A - APROVADO</p>
              <p class="m-0 p-0 legenda-text">R - REPROVADO</p>
              <p class="m-0 p-0 legenda-text">NA - NÃO APLICÁVEL</p>
            </b-col>
          </b-row>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::: PARTE INFERIOR DO RELATORIO :::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="mt-2 p-0 pl-3 pr-3">
              <div class="separador-div">
                <strong>INSPETOR</strong>
              </div>
            </b-col>
            <b-col cols="4" class="mt-2 p-0"> </b-col>
            <b-col cols="4" class="mt-2 p-0 pl-3 pr-3">
              <div class="separador-div">
                <strong>CLIENTE</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="text-left ml-2 mr-2 mb-2">
            <b-col cols="4">
              <inspetor-stamp
                :profissional="pm.inspetor"
                :preview="stampInspetor"
                :posicao="'6rem'"
                key="insp-stamp-pm"
              />
            </b-col>
            <b-col cols="4" class="m-0 p-0"> </b-col>
            <b-col cols="4">
              <div class="borda-cliente">
                <b-img
                  :src="
                    logoCliente == null
                      ? require('/static/images/sgcq_default.png')
                      : logoCliente
                  "
                  class="rounded-0"
                  fluid
                />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <pm-modal ref="tParticulaMagnetica" />
    <imagem-list-modal ref="imgListPM" @loadImagem="loadImagem($event)" />
    <!-- ::::::::::::::: COMANDOS DO RELATÓRIO ::::::::::::::: -->
    <div class="menu-acoes p-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <h4 class="exo-1 m-0 mr-2">SGCQ</h4>
            <b-form-input
              id="sgcq-call"
              type="number"
              size="sm"
              class="m-1 p-1"
              placeholder="Sgcq"
              v-model="sgcq"
            />
            <b-button
              size="sm"
              class="ml-1 pl-2 pr-3"
              variant="primary"
              @click="loadEquipamento()"
            >
              <b-icon
                icon="box-arrow-in-up-right"
                variant="light"
                scale="1.1"
                class="mr-2"
              />Buscar
            </b-button>
            <b-button
              size="sm"
              class="ml-1 pl-2 pr-3"
              variant="info"
              @click="loadDetalhes()"
            >
              <b-icon
                icon="file-earmark-richtext"
                variant="light"
                scale="1.1"
                class="mr-2"
              />Detalhes
            </b-button>
            <b-button
              size="sm"
              class="ml-2 pl-2 pr-3"
              variant="warning"
              v-print="printLaudo"
            >
              <b-icon
                icon="printer"
                variant="light"
                scale="1.1"
                class="mr-2"
              />Imprimir
            </b-button>

            <b-form-radio-group
              id="radio-group-1"
              v-model="fonteDaImagem"
              name="radio-sub-component"
              buttons
              button-variant="outline-light"
              size="sm"
              class="conf-bar"
            >
              <b-form-radio value="equipamento">Equipamento</b-form-radio>
              <b-form-radio value="banco">Banco de Imagem</b-form-radio>
            </b-form-radio-group>

            <b-form-input
              id="size-lines"
              type="number"
              size="sm"
              class="m-1 p-1"
              v-model="linhas"
            />
          </b-form>
        </b-col>
      </div>
    </div>
  </b-tab>
</template>
<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import Files from "@/http/files";
import StampCertificado from "@/components/supports/StampCertificado";
import Cliente from "@/models/Cliente";
import Equipamento from "@/models/Equipamento";
import ImagemListModal from "@/components/modals/imagem/ImagemListModal";
import ReportFields from "@/tools/ReportFields";
import ParticulaMagnetica from "@/models_reports/ParticulaMagnetica";
import ParticulaMagneticaModal from "@/components/modals/relatorio/ParticulaMagneticaModal";

export default {
  name: "ParticulaMagneticaReport",

  components: {
    "inspetor-stamp": StampCertificado,
    "pm-modal": ParticulaMagneticaModal,
    "imagem-list-modal": ImagemListModal,
  },

  data() {
    return {
      sgcq: 0,
      ativo: false,
      fields: new ReportFields(),
      pm: new ParticulaMagnetica(),
      cliente: new Cliente(0, "Novo Cliente", "", "", "", "", "", "", ""),
      equipamento: new Equipamento(
        0,
        "Novo Equipamento",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      ),
      identificacao: "",
      stampInspetor: null,
      logoCliente: null,
      fonteDaImagem: "equipamento",
      imagem: null,
      printLaudo: {
        id: "ParticulaMagnetica",
        popTitle: "SGCQ - Sistema de Gestão e Controle da Qualidade",
      },
      files: new Files(this.$http),
      linhas: 4,
    };
  },

  watch: {
    fonteDaImagem: function (newValue) {
      this.imagem = null;
      if (newValue == "banco") {
        this.$refs.imgListPM.call();
      }
    },
  },

  methods: {
    loadEquipamento() {
      if (this.sgcq != 0 && this.sgcq != "") {
        this.equipamento.update(this.getBySgcq(this.sgcq)[0]);
        this.cliente.update(this.equipamento.cliente);
        this.equipamentoStore
          .LISTAR_SERVICOS(this.equipamento.sgcq)
          .then(() => {
            let servicoData = new Date(this.getLastServico[0].data);
            this.pm.data = new Date(this.getLastServico[0].data);
            let ano = servicoData.getFullYear();
            this.pm.numero =
              "RN" +
              this.getLastServico[0].id +
              "-" +
              this.sgcq +
              "-" +
              ano +
              "-PM";
            this.identificacao = this.equipamento.sgcq;
            if (
              this.equipamento.codigo != "" &&
              this.equipamento.codigo != "- - -"
            ) {
              this.identificacao =
                this.equipamento.sgcq + " - " + this.equipamento.codigo;
            }

            //carrega a imagem do equipamento
            if (this.fonteDaImagem == "equipamento") {
              this.files
                .downloadEquipamento(this.equipamento.sgcq)
                .then((response) => {
                  const reader = new FileReader();
                  const blob = new Blob([response]);
                  reader.readAsDataURL(blob);
                  reader.onload = (e) => {
                    this.imagem = e.target.result;
                  };
                });
            }

            //carrega a logomarca do cliente
            this.files.downloadLogo(this.cliente.id).then((response) => {
              const reader = new FileReader();
              const blob = new Blob([response]);
              reader.readAsDataURL(blob);
              reader.onload = (e) => {
                this.logoCliente = e.target.result;
              };
            });
          });
      }
    },

    loadDetalhes() {
      this.$refs.tParticulaMagnetica.call(this.pm);
    },

    loadImagem(imagem) {
      this.imagem = imagem;
    },

    getIdentification() {
      let id = this.equipamento.sgcq;
      if (this.equipamento.codigo != "" && this.equipamento.codigo != "- - -") {
        id = id + " - " + this.equipamento.codigo;
      }
      return id;
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipamentoStore = useEquipamentoStore();
    const { getBySgcq } = storeToRefs(equipamentoStore);
    const { getLastServico } = storeToRefs(equipamentoStore);

    return {
      store,
      equipamentoStore,
      getBySgcq,
      getLastServico,
    };
  },
};
</script>
<style lang="scss" scoped>
#screen-form {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 82vh;
}

.exo-1 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: italic;
  font-size: 1.4rem;
  padding: 0;
  color: white;
}

.exo-2 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: italic;
  font-size: 1.8rem;
  text-align: center;
}

.separador-div {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  background-color: #1e5555;
  border-radius: 4px;
  color: white;
  text-align: justify; /* For Edge */
  text-align-last: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.borda-cliente {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding-top: 1rem;
  padding-left: 3rem;
  min-height: 8.8rem;
}

.menu-acoes {
  background-color: #112a4a;
}

.legend {
  border: 1px solid lightgray;
  font-size: 0.8rem;
}

#sgcq-call {
  width: 6rem;
}

#size-lines {
  width: 4rem;
}

.conf-bar {
  margin-left: 15rem;
}
</style>
